import { BoardApi } from './boardApi';
import { AiApi } from './aiApi';
import { CardsApi } from './cardsApi';
import { WallsClient, WallsApiError } from './client';
import { ClustersApi } from './clustersApi';
import { ConnectionsApi } from './connectionsApi';
import { ParticipantsApi } from './participantsApi';
import { ShapesApi } from './shapesApi';
import { wallStorage } from './storage';

const client = new WallsClient();
const aiApi = new AiApi(client);
const boardApi = new BoardApi(client);
const cardsApi = new CardsApi(client);
const clustersApi = new ClustersApi(client);
const connectionsApi = new ConnectionsApi(client);
const shapesApi = new ShapesApi(client);
const participantsApi = new ParticipantsApi(client);

export const wallsApi = {
  getRealtimeToken: (boardId: string) => client.requestJson<{ token: string }>(
    '/realtime/token', boardId, undefined,
    { method: 'POST', body: JSON.stringify({ kind: 'wall', id: boardId }) }
  ),
  getSharingVerification: () => client.requestJson<{ user: { emailVerified?: boolean } }>('/users'),
  requestEmailVerification: () => client.requestJson('/users/email-verification/request', undefined, undefined, { method: 'POST', body: '{}' }),
  groupCardsByTheme: aiApi.groupCardsByTheme,
  getThemeGroupingJob: aiApi.getThemeGroupingJob,
  getBoard: boardApi.getBoard,
  getBoardRequiresAuthentication: boardApi.getBoardRequiresAuthentication,
  authenticateBoard: boardApi.authenticateBoard,
  sendInvitations: boardApi.sendInvitations,
  sendFeedback: boardApi.sendFeedback,
  saveWallTemplate: boardApi.saveWallTemplate,
  getWallTheme: boardApi.getWallTheme,
  updateWallTheme: boardApi.updateWallTheme,
  setAutoAlign: boardApi.setAutoAlign,
  setAllowDrawingTools: boardApi.setAllowDrawingTools,
  setAllowCardCreation: boardApi.setAllowCardCreation,
  setAllowClustering: boardApi.setAllowClustering,
  setAllowCardResizing: boardApi.setAllowCardResizing,
  setAllowCardLocking: boardApi.setAllowCardLocking,
  setAllowCardUnlocking: boardApi.setAllowCardUnlocking,
  setAllowAiTools: boardApi.setAllowAiTools,
  setShowCardOwnerNames: boardApi.setShowCardOwnerNames,

  getCardImageUrl: cardsApi.getCardImageUrl,
  getCards: cardsApi.getCards,
  insertTextCard: cardsApi.insertTextCard,
  updateTextCard: cardsApi.updateTextCard,
  updateImageCard: cardsApi.updateImageCard,
  updateCardPosition: cardsApi.updateCardPosition,
  updateCardSize: cardsApi.updateCardSize,
  duplicateCard: cardsApi.duplicateCard,
  lockCard: cardsApi.lockCard,
  unlockCard: cardsApi.unlockCard,
  convertCardToCluster: cardsApi.convertCardToCluster,
  unclusterCard: cardsApi.unclusterCard,
  updateCardZIndexes: cardsApi.updateCardZIndexes,
  setCardColor: cardsApi.setCardColor,
  deleteCard: cardsApi.deleteCard,
  uploadImageCards: cardsApi.uploadImageCards,

  insertCluster: clustersApi.insertCluster,
  updateClusterPosition: clustersApi.updateClusterPosition,
  addCardToCluster: clustersApi.addCardToCluster,
  detachCardFromCluster: clustersApi.detachCardFromCluster,
  createClusterFromCard: clustersApi.createClusterFromCard,
  addClusterToCluster: clustersApi.addClusterToCluster,
  detachClusterFromCluster: clustersApi.detachClusterFromCluster,
  collapseCluster: clustersApi.collapseCluster,
  expandCluster: clustersApi.expandCluster,
  lockCluster: clustersApi.lockCluster,
  unlockCluster: clustersApi.unlockCluster,
  updateCluster: clustersApi.updateCluster,
  deleteCluster: clustersApi.deleteCluster,
  sortCluster: clustersApi.sortCluster,

  getConnections: connectionsApi.getConnections,
  insertConnection: connectionsApi.insertConnection,
  updateConnectionColor: connectionsApi.updateConnectionColor,
  deleteConnection: connectionsApi.deleteConnection,

  getShapes: shapesApi.getShapes,
  insertShape: shapesApi.insertShape,
  updateShape: shapesApi.updateShape,
  deleteShape: shapesApi.deleteShape,
  updateShapeLocked: shapesApi.updateShapeLocked,
  updateShapeZIndexes: shapesApi.updateShapeZIndexes,

  addParticipant: participantsApi.addParticipant,
  deleteParticipants: participantsApi.deleteParticipants,
  addGroup: participantsApi.addGroup,
  updateGroup: participantsApi.updateGroup,
  deleteGroup: participantsApi.deleteGroup,
  setGroupParticipants: participantsApi.setGroupParticipants,
};

export { WallsApiError, wallStorage };
